import { render, staticRenderFns } from "./InternetSpeed.vue?vue&type=template&id=6760c86f&"
import script from "./InternetSpeed.vue?vue&type=script&lang=js&"
export * from "./InternetSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports